import React from 'react';
import styles from './EditSegment.module.css';

interface SegmentNameDescriptionProps {
  name: string;
  description: string;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
}

export const SegmentNameDescription: React.FC<SegmentNameDescriptionProps> = ({
  name,
  description,
  onNameChange,
  onDescriptionChange,
}) => {
  return (
    <hgroup className={styles.nameDescription}>
      <input
        type="text"
        value={name}
        onChange={e => onNameChange(e.target.value)}
        placeholder="Segment Name"
      />
      <input
        type="text"
        value={description}
        onChange={e => onDescriptionChange(e.target.value)}
        placeholder="Add a description..."
      />
    </hgroup>
  );
};
